/**
 * The V2 response envelope (property-within-main/docs/v2/api-description.md).
 * Shape-identical to V1's, plus `code` on errors.
 */
export interface SuccessEnvelope<T = unknown> {
  success: true
  message: string
  data?: T
}

export interface ErrorEnvelope {
  success: false
  message: string
  code: string
  errors?: Record<string, string[]>
}

export type Envelope<T = unknown> = SuccessEnvelope<T> | ErrorEnvelope

export interface Paginated<T> {
  count: number
  total_pages: number
  current_page: number
  page_size: number
  next: string | null
  previous: string | null
  next_cursor?: string | null
  previous_cursor?: string | null
  results: T[]
}

export function isErrorEnvelope(body: unknown): body is ErrorEnvelope {
  return (
    typeof body === 'object' &&
    body !== null &&
    (body as { success?: unknown }).success === false &&
    typeof (body as { code?: unknown }).code === 'string'
  )
}
